export default __webpack_public_path__ + "static/media/Graph3.2602951c.svg";